import React from 'react';
import styled from 'styled-components';
import Title from '@/components/Title';
import { graphql } from 'gatsby';

import BlockWrapper from '@/components/BlockWrapper';
import { getFontColorByBackground } from '@/utils/StyleUtils';
import ArticleBlock, { ArticleBlockType } from '../blog/ArticleBlock';
import Link, { LinkStyle, LinkType } from '@/components/Link';
import { mediaQuery } from '@/utils/helpers';

const CardsWrapper = styled.div`
  margin: 0 0.4rem;
  ${mediaQuery.md(`
  position:relative;
  margin: 0 -1.2rem;
  &:before{
    content:"";
    position:relative;
    width:10px;
    height:10px;  
  }
`)}
`;

const BlockContent = styled.div`
  text-align: center;
`;

const ArticlesBlockContent = styled.div`
  overflow-x: clip;
`;

const ArticleLinkWrapper = styled.div`
  text-align: center;
  padding-top: 28px;
  ${mediaQuery.lg(`
  padding-top: 64px;
  `)}
`;
const CardsList = styled.ul`
  display: flex;
  overflow-x: scroll;
  padding: 20px 0;
  margin-bottom: 0;
  scroll-snap-type: x mandatory;
  ${mediaQuery.lg(`
    overflow: hidden;
    margin: auto;
  `)}
`;

const ArticleContainer = styled.div`
  ${mediaQuery.md(`
    max-width: 1160px;
    width: 100%;
    padding-right: 1.6rem;
    padding-left: 1.6rem;
    margin-right: auto;
    margin-left: auto;
`)}
`;

export type ArticlesBlockType = {
  id: string;
  __typename?: string;
  contentful_id?: string;
  title: string;
  backgroundColor: string;
  articles: Array<ArticleBlockType>;
  link?: LinkType;
};
type Props = ArticlesBlockType;
const ArticlesBlock: React.FC<Props> = ({
  id,
  title,
  backgroundColor,
  articles,
  link,
}) => {
  const fontColor = getFontColorByBackground(backgroundColor);

  const margin = '0 1.5rem';
  return (
    <BlockWrapper
      id={id}
      color={backgroundColor}
      padding={'small'}
      overflow={'hidden'}
    >
      <ArticlesBlockContent>
        <ArticleContainer>
          <BlockContent>
            <Title
              size='xl'
              level='h2'
              margin='0 0 2.8rem'
              lightColor={fontColor === 'White'}
            >
              {title}
            </Title>
          </BlockContent>
          {articles && (
            <CardsWrapper>
              <CardsList>
                {React.Children.toArray(
                  articles.map((article, index) => {
                    return (
                      <ArticleBlock
                        key={index}
                        {...article}
                        index={index}
                        margin={margin}
                        hasTags={false}
                      />
                    );
                  }),
                )}
              </CardsList>
            </CardsWrapper>
          )}
          {link && (
            <ArticleLinkWrapper>
              <Link {...link} linkStyle={LinkStyle.SECONDARY} />
            </ArticleLinkWrapper>
          )}
        </ArticleContainer>
      </ArticlesBlockContent>
    </BlockWrapper>
  );
};

export default ArticlesBlock;
export const largeCardsBlockFragmentQuery = graphql`
  fragment ArticlesBlockFragment on ContentfulArticlesBlock {
    contentful_id
    id
    __typename
    title
    link {
      ...LinkFragment
    }
    backgroundColor
    tags {
      ...ArticleTagFragment
    }
  }
`;
